import React, { useState, useEffect } from "react";
import {
  PieChart, Pie, Cell, LineChart, Line, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer
} from "recharts";
import "./Page.css";

const Assets = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  const [totalDevice, setTotalDevice] = useState(10);
  const [healthy, setHealthy] = useState(1);
  const [unhealthy, setUnhealthy] = useState(4);
  const [pending, setPending] = useState(5);

  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedOwner, setSelectedOwner] = useState("");
  const [filteredOwners, setFilteredOwners] = useState([]);

  const allDevices = [
    { id: 1, deviceId: "BIHSARSDA-01", date: "2022-06-01", owner: "D. Kumar", location: "Bhojpur" },
    { id: 2, deviceId: "BIHSARSDA-02", date: "2022-06-05", owner: "J. Kumar", location: "Patna" },
    { id: 3, deviceId: "BIHSARSDA-03", date: "2022-06-05", owner: "F. Kumar", location: "Buxar" },
    { id: 4, deviceId: "BIHSARSDA-04", date: "2022-06-07", owner: "F. Kumar", location: "Bhojpur" },
    { id: 5, deviceId: "BIHSARSDA-05", date: "2022-06-09", owner: "S. Kumar", location: "Kaimur" },
  ];

  const [filteredData, setFilteredData] = useState(allDevices);
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];
  const pieData = [
    { name: "Healthy", value: healthy },
    { name: "Unhealthy", value: unhealthy },
    { name: "Pending", value: pending },
  ];
  const lineData = [
    { name: "Jan", healthy: 3, unhealthy: 2 },
    { name: "Feb", healthy: 2, unhealthy: 3 },
    { name: "Mar", healthy: 4, unhealthy: 1 },
    { name: "Apr", healthy: 5, unhealthy: 3 },
  ];

  // Get unique districts dynamically
  const districts = [...new Set(allDevices.map(device => device.location))];

  // Update owner list dynamically when district changes
  useEffect(() => {
    if (selectedDistrict) {
      const ownersInDistrict = allDevices
        .filter(item => item.location.toLowerCase() === selectedDistrict.toLowerCase())
        .map(item => item.owner);
      setFilteredOwners([...new Set(ownersInDistrict)]);
    } else {
      // If no district selected, show all owners
      const allOwners = allDevices.map(item => item.owner);
      setFilteredOwners([...new Set(allOwners)]);
    }

    // Reset selected owner whenever district changes
    setSelectedOwner("");
  }, [selectedDistrict]);

  const handleView = () => {
    let result = allDevices;

    if (selectedDistrict) {
      result = result.filter(
        item => item.location.toLowerCase() === selectedDistrict.toLowerCase()
      );
    }

    if (selectedOwner) {
      result = result.filter(item => item.owner === selectedOwner);
    }

    setFilteredData(result);
  };

  const handleShowAll = () => {
    setFilteredData(allDevices);
    setSelectedOwner("");
    setSelectedDistrict("");
  };

  const handleRowClick = (row) => {
    setSelectedRow(row);
    setOpen(true);
  };

  return (
    <div className="container" style={{ minHeight: "100vh" }}>
      {/* Summary Cards */}
      <div className="summary-grid">
        <div className="card card-summary">
          <h6 style={{ fontSize: '18px', fontWeight: '500', margin: '0.8rem 0' }}>Total Devices</h6>
          <div className="card-value">{totalDevice}</div>
        </div>
        <div className="card card-summary">
          <h6 style={{ fontSize: '18px', fontWeight: '500', margin: '0.8rem 0' }}>Healthy</h6>
          <div className="card-value">{healthy}</div>
        </div>
        <div className="card card-summary">
          <h6 style={{ fontSize: '18px', fontWeight: '500', margin: '0.8rem 0' }}>Unhealthy</h6>
          <div className="card-value">{unhealthy}</div>
        </div>
        <div className="card card-summary">
          <h6 style={{ fontSize: '18px', fontWeight: '500', margin: '0.8rem 0' }}>Pending</h6>
          <div className="card-value">{pending}</div>
        </div>
      </div>

      {/* Charts */}
      <div className="charts-grid">
        <div className="card chart-card" style={{ height: 350 }}>
          <h6 style={{ fontSize: '16px', fontWeight: '600', margin: '0.8rem 0' }}>Device Health Overview</h6>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={pieData}
                cx="50%"
                cy="50%"
                outerRadius={isMobile ? 70 : 80}
                dataKey="value"
                label={({ name, value }) => `${name}: ${value}`}
                labelLine={false}
                style={{ fontSize: '16px' }}
              >
                {pieData.map((entry, index) => (
                  <Cell key={index} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>

        <div className="card chart-card" style={{ height: 350 }}>
          <h6 style={{ fontSize: '16px', fontWeight: '600', margin: '0.8rem 0' }}>Monthly Device Status</h6>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={lineData}>
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend verticalAlign="top" height={36} />
              <Line type="monotone" dataKey="healthy" stroke="#00C49F" />
              <Line type="monotone" dataKey="unhealthy" stroke="#FF8042" />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Recent Alerts + Map */}
<div className="card inventory-card">
  <h6 style={{ fontSize: '18px', fontWeight: '600', margin: '0.8rem 0' }}>
    Recent Alerts
  </h6>

  {/* Two-column layout for Alerts + Map */}
  <div
    style={{
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '1rem',
      alignItems: 'flex-start',
    }}
  >
    {/* Left: Alerts list */}
    <div className="alert-list" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
      {[{ id: 1, message: "Device A - Power failure", time: "2 mins ago" },
        { id: 2, message: "Device B - Disconnected", time: "10 mins ago" },
        { id: 3, message: "Device C - Disconnected", time: "30 mins ago" }].map(alert => (
        <div
          key={alert.id}
          className="alert-card"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            background: '#fafafa',
            border: '1px solid #ddd',
            borderRadius: '8px',
            padding: '0.6rem 1rem',
          }}
        >
          <span>{alert.message}</span>
          <span style={{ fontSize: '12px', color: '#666' }}>{alert.time}</span>
        </div>
      ))}
    </div>

    {/* Right: Map */}
    <div
      className="map-container"
      style={{
        height: '100%',
        minHeight: '200px',
        borderRadius: '8px',
        overflow: 'hidden',
      }}
    >
      <iframe
        title="Google Map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1984.123456!2d-0.09!3d51.505!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNTHCsDAzJzAwLjAiTiAwwrAwNScwMC4iRQ!5e0!3m2!1sen!2sin!4v0000000000000"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  </div>
</div>


      {/* Device Inventory */}
      <div className="card inventory-card">
        <h6 style={{ fontSize: '18px', fontWeight: '600', margin: '0.8rem 0' }}>Device Inventory</h6>
        <div className="filters">
          <select value={selectedDistrict} onChange={e => setSelectedDistrict(e.target.value)}>
            <option value="">District</option>
            {districts.map((district, idx) => (
              <option key={idx} value={district}>{district}</option>
            ))}
          </select>

          <select value={selectedOwner} onChange={e => setSelectedOwner(e.target.value)} disabled={!selectedDistrict}>
            <option value="">Owner</option>
            {filteredOwners.map((owner, idx) => (
              <option key={idx} value={owner}>{owner}</option>
            ))}
          </select>

          <button className="btn-view" onClick={handleView}>View</button>
          <button className="btn-showall" onClick={handleShowAll}>Show All</button>
        </div>

        <div style={{ overflowX: "auto" }}>
          <table>
            <thead>
              <tr>
                <th>S no</th>
                <th>Device ID</th>
                <th>Date Of Installation</th>
                <th>Owner</th>
                <th>Location</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? filteredData.map((row, index) => (
                <tr key={row.id} onClick={() => handleRowClick(row)}>
                  <td>{index + 1}</td>
                  <td>{row.deviceId}</td>
                  <td>{row.date}</td>
                  <td>{row.owner}</td>
                  <td>{row.location}</td>
                </tr>
              )) : (
                <tr>
                  <td colSpan="5" align="center">No data found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal */}
      {open && (
        <div className="modal" onClick={() => setOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h6 style={{ fontSize: "20px", fontWeight: "bold", margin: '0.25rem 0rem 2rem' }}>Device Details</h6>
            {selectedRow && (
              <div className="modal-details">
                <p style={{ fontSize: '16px' }}><b>Device ID:</b> {selectedRow.deviceId}</p>
                <p style={{ fontSize: '16px' }}><b>Date of Installation:</b> {selectedRow.date}</p>
                <p style={{ fontSize: '16px' }}><b>Owner:</b> {selectedRow.owner}</p>
                <p style={{ fontSize: '16px' }}><b>Location:</b> {selectedRow.location}</p>
              </div>
            )}
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1rem' }}>
              <button className="btn-close" onClick={() => setOpen(false)}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Assets;
